import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import { GetAutomaticAdviceResponse } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class AutomaticAdviceApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected arableAdviceBaseUrl = this.env.APIM_BASE_URL + '/arable-advice-service/automatic-advice/';

  getAutomaticAdvice(year: number): Observable<GetAutomaticAdviceResponse | undefined> {
    return this.http.get<GetAutomaticAdviceResponse>(`${this.arableAdviceBaseUrl}customer/year/${year}`);
  }
}
